var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500.808,
    height: 500.176,
    viewBox: "0 0 500.808 500.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1081 769.263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 28.1,
    height: 9.917,
    transform: "translate(1330.432 -741.167) rotate(-89.081)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 28,
    height: 9.918,
    transform: "translate(1319.706 -269.247) rotate(-89.08)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 28,
    height: 9.917,
    transform: "matrix(0.897, -0.441, 0.441, 0.897, 1103.397, -414.918)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 28.1,
    height: 9.917,
    transform: "translate(1528.721 -622.981) rotate(-26.169)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 28,
    height: 9.917,
    transform: "translate(1095.318 -432.291) rotate(-21.46)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 28.1,
    height: 9.916,
    transform: "translate(1536.157 -606.143) rotate(-21.464)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 28,
    height: 9.918,
    transform: "translate(1088.557 -450.769) rotate(-17.111)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 28,
    height: 9.917,
    transform: "translate(1542.211 -589.984) rotate(-17.103)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 28,
    height: 9.918,
    transform: "translate(1085.048 -468.683) rotate(-12.722)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 28,
    height: 9.917,
    transform: "translate(1547.015 -573.409) rotate(-12.746)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 28,
    height: 9.916,
    transform: "translate(1082.952 -487.364) rotate(-8.36)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 28,
    height: 9.915,
    transform: "translate(1550.545 -556.52) rotate(-8.374)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 28,
    height: 9.916,
    transform: "translate(1081.286 -506.225) rotate(-4.014)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 28,
    height: 9.916,
    transform: "translate(1552.781 -539.412) rotate(-4.003)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 9.917,
    height: 28.1,
    transform: "translate(1081 -515.246) rotate(-89.646)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 9.916,
    height: 28.1,
    transform: "translate(1553.646 -512.266) rotate(-89.634)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 9.916,
    height: 28.1,
    transform: "translate(1081.461 -534.18) rotate(-85.275)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 9.917,
    height: 28.1,
    transform: "translate(1552.584 -494.866) rotate(-85.275)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 9.916,
    height: 28.1,
    transform: "matrix(0.158, -0.987, 0.987, 0.158, 1083.363, -553.024)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 9.916,
    height: 28.1,
    transform: "matrix(0.158, -0.987, 0.987, 0.158, 1550.133, -477.788)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 9.917,
    height: 28.1,
    transform: "matrix(0.233, -0.973, 0.973, 0.233, 1086.695, -571.663)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 9.917,
    height: 28.09,
    transform: "translate(1546.392 -460.94) rotate(-76.547)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 9.916,
    height: 28.1,
    transform: "translate(1091.435 -590.002) rotate(-72.171)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 9.916,
    height: 28,
    transform: "translate(1541.837 -444.964) rotate(-72.171)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 9.916,
    height: 28.1,
    transform: "matrix(0.378, -0.926, 0.926, 0.378, 1097.215, -608.92)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 9.918,
    height: 28,
    transform: "translate(1535.118 -428.963) rotate(-67.81)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 9.917,
    height: 28.1,
    transform: "translate(1104.023 -626.322) rotate(-63.455)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 9.917,
    height: 28,
    transform: "matrix(0.447, -0.895, 0.895, 0.447, 1527.202, -414.19)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 9.918,
    height: 28.1,
    transform: "matrix(0.514, -0.858, 0.858, 0.514, 1112.097, -643.111)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 9.919,
    height: 28,
    transform: "translate(1517.897 -397.508) rotate(-59.076)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 9.917,
    height: 28,
    transform: "translate(1122.818 -659.229) rotate(-54.706)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 9.917,
    height: 28,
    transform: "translate(1507.571 -385.303) rotate(-54.724)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 9.916,
    height: 28,
    transform: "translate(1134.036 -674.438) rotate(-50.352)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 9.917,
    height: 28,
    transform: "translate(1497.439 -371.192) rotate(-50.35)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 9.917,
    height: 28,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 1146.382, -689.801)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 9.916,
    height: 28,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 1485.655, -358.59)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 9.918,
    height: 28,
    transform: "translate(1158.783 -702.006) rotate(-41.614)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 9.917,
    height: 28,
    transform: "matrix(0.748, -0.664, 0.664, 0.748, 1473.232, -347.468)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 9.916,
    height: 28,
    transform: "matrix(0.796, -0.605, 0.605, 0.796, 1174.406, -715.5)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 9.917,
    height: 28,
    transform: "translate(1460.81 -337.106) rotate(-37.26)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 9.918,
    height: 28,
    transform: "matrix(0.84, -0.543, 0.543, 0.84, 1188.683, -725.687)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 9.918,
    height: 28,
    transform: "translate(1446.474 -328.656) rotate(-32.894)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 9.916,
    height: 28,
    transform: "matrix(0.879, -0.478, 0.478, 0.879, 1204.646, -736.047)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 9.916,
    height: 28,
    transform: "translate(1431.541 -321.061) rotate(-28.538)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 9.917,
    height: 28,
    transform: "matrix(0.912, -0.409, 0.409, 0.912, 1222.445, -744.789)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 9.916,
    height: 28,
    transform: "translate(1415.914 -313.743) rotate(-24.166)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 9.917,
    height: 28,
    transform: "matrix(0.941, -0.339, 0.339, 0.941, 1239.863, -752.228)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 9.917,
    height: 28,
    transform: "matrix(0.941, -0.339, 0.339, 0.941, 1399.776, -307.635)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 9.917,
    height: 28,
    transform: "matrix(0.964, -0.266, 0.266, 0.964, 1259.675, -759.813)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 9.916,
    height: 28,
    transform: "translate(1386.221 -303.107) rotate(-15.434)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 9.918,
    height: 28,
    transform: "translate(1278.019 -764.522) rotate(-11.071)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 9.917,
    height: 28,
    transform: "translate(1371.117 -300.363) rotate(-11.06)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,0l9.957-.32-.718,27.68-9.957.32Z",
    transform: "translate(1295.126 -766.443) rotate(-7.065)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 9.916,
    height: 28,
    transform: "translate(1353.456 -297.598) rotate(-7.065)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0,9.927-.152l-.338,28.1L-.338,28.1Z",
    transform: "matrix(0.998, -0.056, 0.056, 0.998, 1312.851, -768.553)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 9.918,
    height: 28,
    transform: "matrix(0.998, -0.056, 0.056, 0.998, 1337.605, -297.044)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 28,
    height: 9.917,
    transform: "translate(1302.108 -270.916) rotate(-85.209)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 28.1,
    height: 9.916,
    transform: "translate(1345.744 -740.737) rotate(-85.208)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 28,
    height: 9.917,
    transform: "translate(1281.192 -273.541) rotate(-80.372)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 28.1,
    height: 9.914,
    transform: "translate(1362.919 -739.252) rotate(-80.368)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 28,
    height: 9.917,
    transform: "matrix(0.252, -0.968, 0.968, 0.252, 1260.153, -278.051)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 28.1,
    height: 9.917,
    transform: "translate(1382.188 -735.546) rotate(-75.394)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 28,
    height: 9.917,
    transform: "translate(1236.88 -286.138) rotate(-69.999)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 28.1,
    height: 9.915,
    transform: "translate(1399.871 -731.093) rotate(-70.005)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 28,
    height: 9.916,
    transform: "translate(1221.34 -292.956) rotate(-64.976)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 28.1,
    height: 9.915,
    transform: "translate(1417.405 -723.882) rotate(-64.976)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 28,
    height: 9.916,
    transform: "matrix(0.498, -0.867, 0.867, 0.498, 1200.158, -304.681)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 28.1,
    height: 9.915,
    transform: "translate(1433.065 -716.635) rotate(-60.157)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 28,
    height: 9.918,
    transform: "translate(1183.052 -317.266) rotate(-55.333)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 28.1,
    height: 9.915,
    transform: "matrix(0.569, -0.822, 0.822, 0.569, 1449.401, -706.817)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 28,
    height: 9.918,
    transform: "translate(1167.684 -329.942) rotate(-50.515)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 28.1,
    height: 9.917,
    transform: "matrix(0.636, -0.772, 0.772, 0.636, 1467.675, -693.935)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 28,
    height: 9.917,
    transform: "translate(1150.078 -342.995) rotate(-45.682)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 28.1,
    height: 9.917,
    transform: "translate(1482.135 -681.521) rotate(-45.689)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 28,
    height: 9.916,
    transform: "translate(1136.34 -360.513) rotate(-40.851)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 28.1,
    height: 9.915,
    transform: "translate(1494.767 -670.247) rotate(-40.858)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 28,
    height: 9.916,
    transform: "translate(1124.004 -377.152) rotate(-36.032)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 28.1,
    height: 9.917,
    transform: "matrix(0.808, -0.589, 0.589, 0.808, 1506.945, -655.579)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 28,
    height: 9.918,
    transform: "matrix(0.855, -0.518, 0.518, 0.855, 1114.176, -394.501)",
    fill: "#7cfc00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 28.1,
    height: 9.916,
    transform: "matrix(0.855, -0.518, 0.518, 0.855, 1517.845, -639.944)",
    fill: "#7cfc00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircle);
export default __webpack_public_path__ + "static/media/green-circle.dceb711c438c2c823eb6a1001abcf6bf.svg";
export { ForwardRef as ReactComponent };